import { styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';

export const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;
`;

export const TooltipText = styled.div`
  width: 156px;
  padding: 12px;
  position: absolute;
  bottom: 100%;
  left: 50%;
  z-index: 1;
  transform: translateX(-50%);
  background-color: #3c3c3c;
  border-radius: 8px;
  box-shadow: 0 4px 16px 0 rgba(8 4 13 / 25%);
  color: ${uiToken.color.text.primary};
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
  opacity: 0;
  pointer-events: none;
  transition-duration: 0.2s;
  transition-property: bottom, opacity;
  transition-timing-function: ease-in-out;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    z-index: 2;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: #3c3c3c transparent transparent;
  }
`;

export const Root = styled(TooltipContainer)`
  &:hover ${TooltipText} {
    bottom: calc(100% + 8px);
    opacity: 1;
    pointer-events: all;
  }
`;
